/**
 * Show and hide the search form.
 */

define('libs/searchform',['require','libs/utilities.requestanimationframe'],function(require) {

    'use strict';

    require('libs/utilities.requestanimationframe');

    var SETTINGS = {
        linkSelector: '#lnk-search',
        formSelector: '#form-search',
        inputSelector: '#q',
        classVisible: 'visible',
        classActive: 'active',
        animationTime: 500 // time set for the css transition ont he form.
    };

    var SearchForm = function(settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});

        this.button = $(this.settings.linkSelector);
        this.form = $(this.settings.formSelector);

        this.keyDownHandler = this.onKeyDown.bind(this);
        this.closeOnClickHandler = this.onClick.bind(this);

        this.button.on('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.active ? this.hide() : this.show();
            $('.form-search input[type="search"]').focus();
        }.bind(this));
    };

    /**
     * Show the form.
     */
    SearchForm.prototype.show = function() {
        if (this.active) {
            return;
        }
        this.form.addClass(this.settings.classVisible);
        requestAnimationFrame(function() {
            this.form.addClass(this.settings.classActive);
            this.button.addClass(this.settings.classActive);
        }.bind(this));

        // start listening for the esc key.
        $(window).on('keydown', this.keyDownHandler);

        // start listening for clicks to close the form.
        this.form.on('click', this.closeOnClickHandler);

        this.active = true;
    };

    /**
     * Hide the form.
     */
    SearchForm.prototype.hide = function() {
        this.form.removeClass(this.settings.classActive);
        this.button.removeClass(this.settings.classActive);

        // clear the input.
        $(this.settings.inputSelector).val('');

        // stop listening for the esc key.
        $(window).off('keydown', this.keyDownHandler);

        // stop listening for clicks to close the form.
        this.form.off('click', this.closeOnClickHandler);

        // remove the visible class when the css transition is finished.
        setTimeout(function() {
            this.form.removeClass(this.settings.classVisible);
            this.active = false;
        }.bind(this), this.settings.animationTime + 50);
    };

    /**
     * Hide the form when the esc key is pressed.
     * @param {Event} event The keyboard event.
     */
    SearchForm.prototype.onKeyDown = function(event) {
        if (event.keyCode == 27) { // ESC key
            this.hide();
        }
    };

    /**
     * Hide the form when clicking the overlay.
     * @param {Event} event The click event.
     */
    SearchForm.prototype.onClick = function(event) {
        if (!$(event.target).closest('#search', this.form).length) {
            this.hide();
        }
    };

    return SearchForm;
});

